import Cover from "../Cover/Cover"
import Section from "../Home/Section"
import { Button , Dropdown, Option, Spinner} from "@fluentui/react-components"
import ReactMarkdown from  'react-markdown'
import rehypeHighlight from 'rehype-highlight'
import DbService from "../../firebase/DbService"
import {useState, useEffect} from "react"
import {useParams} from "react-router-dom"
import markup from "./about"
import "./blogstyles.css"
const BlogScreen = (props)=>{
    const [loading ,setLoading] = useState(true)
    const [item, setItem] = useState({})
    const {id} = useParams()

    const onFetch=(res)=>{
        setLoading(false)
        setItem(res)
    }
    useEffect(()=>{
        if(!props.about){
        setLoading(true)
        DbService.getItem(onFetch, id)
        }else{
            setLoading(false)
            
            setItem({
                title:"About",
                description:"I'm a recently graduated software engineer with a passion for machine learning. Over the past 3 years, I've been dedicated to exploring the fascinating realm of artificial intelligence, particularly the intricacies of the human brain and the mechanics of learning.",
                links: "https://www.linkedin.com/in/abdul-rauf-03817a166/,https://www.twitter.com/raufie_original, https://www.youtube.com/channel/UC93sfFCG4euSAWO6kYxheUQ",
                markup:markup.markup,
                cover: process.env.PUBLIC_URL+"/contentlistbg.webp"
            
            })
        }
    }, [])
    // props: image, title, description, links, 
    return <div>
        <Cover {...item} font={props.font} about={props.about}/>
          {/* projects section */} 
          
          <div className="ms-Grid-row" style={{marginTop:"5%"}}><div className="ms-Grid-col ms-sm1"></div>
            
            {/* dropdown */}
        </div>
        <div style={{marginLeft:"10%", width:"80%", fontFamily:props.font}} > 
            {
            loading?<div><br/><Spinner /></div>:<ReactMarkdown style={{fontFamily:props.font}}  components={{ p: ({ children }) => <p  className="paragraph">{children}</p>,}} rehypePlugins={[rehypeHighlight]}>{item.markup}</ReactMarkdown>
            }
        </div>
        

        

       
        
        {/* CONTENT SECTION */}
        <div className="ms-Grid-row" style={{marginTop:"2.5%"}}>
        <div className="ms-Grid-col ms-sm1 ms-lg1"></div>
            <div className="ms-Grid-col ms-sm1 ms-lg4">
                <img src={process.env.PUBLIC_URL+"/wave.png"}/>    
            </div>
        </div>
    </div>
}

export default BlogScreen